export default __webpack_public_path__ + "static/hero-background-4ec7d5ded0411bc2cbade16becd20f67.jpg";